/*=========================================================================================
  File Name: moduleTypeConfigCrudMutations.js
  Description: Company Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	// elimina el tipo de configuración seleccionado del state
	REMOVE_TYPECONFIG(state, itemId) {
		const ItemIndex = state.config_list.findIndex((p) => p.id === itemId);
		state.config_list.splice(ItemIndex, 1);
	},
	// inserta los tipos de configuración en el state
	SET_CONFIG_LIST(state, data) {
		state.config_list = data;
	},
};
